import { SettingName } from '@standardnotes/domain-core';
export class MigrateFeatureRepoToUserSettingUseCase {
    constructor(mutator, settings) {
        this.mutator = mutator;
        this.settings = settings;
    }
    async execute(featureRepos = []) {
        for (const item of featureRepos) {
            if (item.migratedToUserSetting) {
                continue;
            }
            if (!item.onlineUrl) {
                continue;
            }
            const repoUrl = item.onlineUrl;
            const userKeyMatch = repoUrl.match(/\w{32,64}/);
            if (userKeyMatch && userKeyMatch.length > 0) {
                const userKey = userKeyMatch[0];
                await this.settings.updateSetting(SettingName.create(SettingName.NAMES.ExtensionKey).getValue(), userKey, true);
                await this.mutator.changeFeatureRepo(item, (m) => {
                    m.migratedToUserSetting = true;
                });
            }
        }
    }
}
